//let mode = "local" // remote for asp.net core backend
//const apiBaseUrl = 'http://localhost:51823//api/'
const apiBaseUrl = window.location.origin + '/api/'
const fetchMode = process.env.REACT_APP_MODE ? process.env.REACT_APP_MODE : ""


async function getOrganisationApi(id) {
  let controller = "Organisations"
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller + "/" + id 
  if (fetchMode === "local") {
    url = "./data/organisation.json"
    request = null
  }
  return await fetchService(url, request) 
}

async function getPutOrganisationApi(id,data) {
  let controller = "Organisations"
  let request = {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken"),
      "Content-Type": "application/json"
    }
  }
  let url = apiBaseUrl + "/" + controller + "/" + id
  if (fetchMode === "local") {
    url = "./data/organisation.json"
    request = null
  }
  return await fetchService(url, request)
}


async function getPutContributorApi(id, data) {
  let controller = "Contributor"
  let request = {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken"),
      "Content-Type": "application/json"
    }
  }
  let url = apiBaseUrl + "/" + controller + "/" + id
  if (fetchMode === "local") {
    url = "./data/contributor.json"
    request = null
  }
  return await fetchService(url, request)
}

async function getPostContributorApi( data) {
  let controller = "Contributor"
  let request = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken"),
      "Content-Type": "application/json"
    }
  }
  let url = apiBaseUrl + "/" + controller 
  if (fetchMode === "local") {
    url = "./data/contributor.json"
    request = null
  }
  return await fetchService(url, request)
}

async function getPostContributionApi(data) {
  let controller = "Contributions"
  let request = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken"),
      "Content-Type": "application/json"
    }
  }
  let url = apiBaseUrl + "/" + controller
  if (fetchMode === "local") {
    url = "./data/postSaveContribution.json"
    request = null
  }
  return await fetchService(url, request)
}



async function getDeleteContributorApi(id) {
  let controller = "Contributor"
  let request = {
    method: "DELETE",
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken"),
      "Content-Type": "application/json"
    }
  }
  let url = apiBaseUrl + "/" + controller + "/" + id
  if (fetchMode === "local") {
    url = "./data/deletedContributor.json"
    request = null
  }
  return await fetchService(url, request)
}




async function getPostFundsApi(data) {
  let controller = "Funds"
  let request = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller
  if (fetchMode === "local") {
    url = "./data/funds.json"
    request = null
  }

  return await fetchService(url, request)
}

async function getContributorApi(id) {
  let controller = "Contributor"
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken"),
    }
  }
  let url = apiBaseUrl + "/" + controller + "/" + id
  if (fetchMode === "local") {
    url = "./data/contributor.json"
    request = null
  }
  return await fetchService(url, request)
}


async function getFundsApi() {
  let controller = "Funds"
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller 
  if (fetchMode === "local") {
    url = "./data/funds.json"
    request = null
  }

  return await fetchService(url, request)
}

async function getNextofferingNoApi() {
  let controller = "Contributor/getNextOfferingNo"
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller 
  if (fetchMode === "local") {
    url = "./data/nextOfferingNo.json"
    request = null
  }
    return await fetchService(url, request)
  }

async function getContributorsApi(qstrings) {
//  console.log("qstrings: " + qstrings)
  let controller = "Contributor/search"
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller + qstrings
  if (fetchMode === "local") {
    url = "./data/contributors.json"
    request = null
  }

  return await fetchService(url, request)
}

async function getContributionApi(dString) {
  let controller = "Contributions/on/" + dString 
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }  }
  let url = apiBaseUrl + "/" + controller 
  if (fetchMode === "local") {
    url = "./data/contributions.json"
    request = null
  }
  return await fetchService(url, request)
}

async function getContributionByMemberApi(Id) {
  //console.log("getContributionByMemberApi: " + Id)
  let controller = "Contributions/member/" + Id
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller
  if (fetchMode === "local") {
    url = "./data/contributionsByMember.json"
    request = null
  }
  return await fetchService(url, request)
}

async function deleteContributionApi(id, dstring ) {
  //console.log(`delete contribution ${id}, ${dstring}`) 
  let controller = `Contributions//${id}//${dstring} `
  let request = {
    method: "DELETE",
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }  }
  let url = apiBaseUrl + "/" + controller 
  //console.log(url)
  if (fetchMode === "local") {
    url = "./data/contributions.json"
    request = null
  }
 // console.log(url)
  return await fetchService(url, request)

}


async function ContributionsDetails(qstrings) {
  let controller = "contributions/details"
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller + qstrings
  if (fetchMode === "local") {
    url = "./data/detailsReport.json"
    request = null
  }

  return await fetchService(url, request)
}


async function getUsers() {
  let controller = "Users/getusers"
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller 
  if (fetchMode === "local") {
    url = "./data/users.json"
    request = null
  }

  return await fetchService(url, request)
}


async function ContributionsReportPager( qstrings ) {
  let controller = "contributions/detailpager"
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller + qstrings
  if (fetchMode === "local") {
    url = "./data/pager.json"
    request = null
  }

  return await fetchService(url, request)
}

async function PostRebateAdjust(data) {
  let controller = "contributions/rebateadjustment"
  let request = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken"),
      "Content-Type": "application/json"
    }
  }
  let url = apiBaseUrl + "/" + controller
  if (fetchMode === "local") {
    url = "./data/postSaveContribution.json"
    request = null
  }
  return await fetchService(url, request)

}

async function RebateAdjustApi( qstrings ) {
  let controller = "contributions/funds"
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller + qstrings
  if (fetchMode === "local") {
    url = "./data/fundrebate.json"
    request = null
  }

  return await fetchService(url, request)
}

async function GetReceiptsApi(qstrings) {
  let controller = "contributions/receipts"
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller + qstrings
  if (fetchMode === "local") {
    url = "./data/receipts.json"
    request = null
  }

  return await fetchService(url, request)
}


async function ContributionsSummaryReportApi( qstrings ) {
  let controller = "contributions/summary"
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller + qstrings
  if (fetchMode === "local") {
    url = "./data/summarybyfund.json"
    request = null
  }

  return await fetchService(url, request)
}

async function ContributorsAutoCompleteApi(qstrings) {
  let controller = "Contributor/autocomplete?filter="
  let request = {
    headers: {
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller + qstrings
  if (fetchMode === "local") {
    url = "./data/autoComplete.json"
    request = null
  }

  return await fetchService(url, request)
}


async function recoverLoginApi(request) {
  let controller = "Users/resetpassword/"
  let req = request
  let url = apiBaseUrl + "/" + controller
  if (fetchMode === "local") {
    url = "./data/user.json"
    req = null
  }
  return await fetchServiceNoContent(url, req)
}



async function usersLoginApi(request) {
  let controller = "Users"
  let req = request 
  let url = apiBaseUrl + "/" + controller 
  if (fetchMode === "local") {
    url = "./data/user.json"
    req = null
  }
  return await fetchService( url, req, true) 
}


async function updateEmailApi(data) {
  let controller = "Users/changeemail"
  let request = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller
  if (fetchMode === "local") {
    url = "./data/user.json"
    request = null
  }
  return await fetchServiceNoContent(url, request)
}

async function updatePasswordApi(data) {
  let controller = "Users/changepassword"
  let request = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller
  if (fetchMode === "local") {
    url = "./data/user.json"
    request = null
  }
  return await fetchService(url, request)
}


async function createUser(data) {
  let controller = "Users/createuser"
  let request = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller
  if (fetchMode === "local") {
    url = "./data/users.json"
    request = null
  }
  return await fetchService(url, request)
}

async function deleteUserApi(id) {
  let controller = "Users/" + id
  let request = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + window.sessionStorage.getItem("jwtToken")
    }
  }
  let url = apiBaseUrl + "/" + controller
  if (fetchMode === "local") {
    url = "./data/users.json"
    request = null
  }
  return await fetchService(url, request)
}



async function fetchServiceNoContent(url, request) {
  try {
    //console.log("url: " + url)
    const response = await fetch(url, request)
    if (response.ok || response.status === 400) {
      return response.ok
    } else {
      //console.log("fetchservice error: " + response.statusText)
      throw new Error(response.status + " " + response.statusText)
    }
  }
  catch (err) {
    console.error("error catched in apiservice.fetchservice function, url:" + url)
    console.error("err:" + err)
    //return err.toString()
    throw new Error(err.toString())
  }
}


async function fetchService(url, request, dontReload) {
  try {
    //console.log("url: " + url)
    const response = await fetch(url, request)
    if (response.ok || response.status === 400) {
      const json = await response.json()
      return response.ok ? json : Promise.reject(json);
    } else {
      //console.log("fetchservice error: " + response.statusText)
      if (response.status === 401) {
        if (!dontReload) {
          window.sessionStorage.removeItem("UserName");
          window.location.href = "/"
        }
        return "Error: 401"
      } else {
        throw new Error(response.status + " " + response.statusText)
      }
    }
  }
  catch (err) {
    //console.log("error catched in apiservice.fetchservice function, url:" + url)
    //console.log("err:" + err)
    return err.toString()
  }
}

export {  fetchMode, ContributorsAutoCompleteApi, getContributionByMemberApi,
  getOrganisationApi, usersLoginApi, getFundsApi, getPostFundsApi, getContributorsApi, getPutOrganisationApi,
  getPutContributorApi, getNextofferingNoApi, getPostContributorApi, getDeleteContributorApi,
  getContributionApi, getPostContributionApi, deleteContributionApi, ContributionsSummaryReportApi,
  ContributionsReportPager, ContributionsDetails, RebateAdjustApi, GetReceiptsApi,
  getContributorApi, PostRebateAdjust, updateEmailApi, updatePasswordApi, recoverLoginApi,
  getUsers, createUser, deleteUserApi }